var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _vm._v(" " + _vm._s(_vm.type) + " "),
            _c(_vm.currentInputComponent, {
              tag: "component",
              attrs: {
                type: _vm.type,
                level: _vm.level,
                param: _vm.param,
                parameter: _vm.parameter,
                config: _vm.config,
                value: _vm.value,
                "selected-user-id": _vm.selectedUserId,
                application: _vm.application,
                "has-permision-save": _vm.hasPermissionSave
              },
              on: { input: _vm.input }
            })
          ],
          1
        )
      ]),
      _c("br"),
      _vm.isSavingConfigurations
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-spinner", {
                  staticClass: "mr-1",
                  attrs: { variant: "primary" }
                }),
                _vm._v(" Guardando ")
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.isSavingConfigurations && _vm.hasPermissionSave
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _vm.environmentCanSave(_vm.level)
                  ? _c(
                      "b-button",
                      {
                        attrs: { variant: "primary", disabled: !_vm.newValue },
                        on: {
                          click: function($event) {
                            return _vm.saveParameter()
                          }
                        }
                      },
                      [_vm._v(" Guardar Configuracion ")]
                    )
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-secondary" },
                    on: {
                      click: function($event) {
                        return _vm.migrateParameter()
                      }
                    }
                  },
                  [_vm._v(" Migrar Configuración ")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "migration",
          attrs: {
            id: "migration-modal",
            title: "Migrar",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "row mb-5" }, [
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", [_vm._v("Ambiente destino")]),
                _c("v-select", {
                  attrs: {
                    multiple: "",
                    label: "title",
                    options: _vm.ambientsOptions
                  },
                  model: {
                    value: _vm.selectedAmbients,
                    callback: function($$v) {
                      _vm.selectedAmbients = $$v
                    },
                    expression: "selectedAmbients"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", [_vm._v("Niveles")]),
                _c("v-select", {
                  attrs: { label: "id", options: _vm.levels },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function(ref) {
                        var id = ref.id
                        return [
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm._f("capitalize")(id)))
                          ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedLevels,
                    callback: function($$v) {
                      _vm.selectedLevels = $$v
                    },
                    expression: "selectedLevels"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-md-12 mt-3" }, [
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _vm.sendingMigration
                    ? _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { variant: "primary" }
                      })
                    : _vm._e(),
                  !_vm.sendingMigration
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "action",
                          attrs: {
                            color: "primary",
                            type: "border",
                            icon: "save"
                          },
                          on: { click: _vm.sendMigrateParameter }
                        },
                        [_vm._v(" Migrar ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }